import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import TabStripProps from './TabStripProps'

import Animation from '../Common/Animation'
import Scrollable from '../Common/Scrollable'

export default {
    template: `<div><slot></slot></div>`,
    props: TabStripProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Scrollable
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoTabStrip(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTabStrip()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoTabStrip/KendoTabStripMixin.js